import {
  Field,
  FieldDescription,
  FieldError,
  FieldLabel,
  FieldTitle,
} from "@/client/components/shad/field";
import { Input } from "@/client/components/shad/input";
import { useFieldContext } from "../form-context";
import { Slider } from "@/client/components/shad/slider";

type Props = {
  min?: number;
  max?: number;
  step?: number;
  label: string;
};

export function SliderField({ label, min = 0, max = 100, step = 1 }: Props) {
  const field = useFieldContext<number[]>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;
  return (
    <Field>
      <Slider
        id={field.name}
        value={field.state.value}
        onValueChange={(value) => field.handleChange(value)}
        min={min}
        max={max}
        step={step}
        className="mt-2 w-full"
      />
      <FieldDescription>Value</FieldDescription>
      {isInvalid && (
        <FieldError className="text-xs" errors={field.state.meta.errors} />
      )}
    </Field>
  );
}
